<template>
  <vx-card :title="title">
    <div v-show="visibleRes">
      <Actions
        @closeReport="closeReport"
        @downloadPdf="downloadPdf"
      />
      <template v-if="result.length">
        <div ref="contentPdf">
          <div v-for="(item,i) in result" :key="i">
            <div class="text-2xl font-bold my-5">{{ item.contact }}</div>
            <template v-for="(matter,index) in item.matters">
              <div class="font-medium my-5">{{ matter.name }}</div>
              <a-table :dataSource="matter.aging" :columns="columns" :pagination="false" >
              <span slot="bill" slot-scope="text,record">
                <a href="#" @click="$router.push(`/billing/dashboard/${record.bill_id}`)">{{ record.bill_id }}</a>
              </span>
                <template slot="footer">
                  <div v-if="matter.aging.length" class="grid grid-cols-6">
                    <div class="font-bold">Total</div>
                    <div>{{ currencySymbol + sumCol(matter.aging,'0-30') }}</div>
                    <div>{{ currencySymbol + sumCol(matter.aging,'31-60') }}</div>
                    <div>{{ currencySymbol + sumCol(matter.aging,'61-90') }}</div>
                    <div>{{ currencySymbol + sumCol(matter.aging,'+91') }}</div>
                    <div class="font-bold">{{ currencySymbol + sumCol(matter.aging,'current') }}</div>
                  </div>
                </template>
              </a-table>
            </template>
          </div>
        </div>
      </template>
      <template v-else>
        <a-empty/>
      </template>
    </div>
    <a-form v-show="!visibleRes" :form="form" @submit.prevent="handleSubmit">
      <selectSearch
        :required="false"
        url="/contact/query/"
        :options="optionSearchContact"
        class="self-end mt-8 md:mt-0 w-full md:w-1/3"
      />
      <selectSearch
        :required="false"
        url="/matter/query/"
        :options="optionSearchMatter"
        class="self-end mt-8 md:mt-0 w-full md:w-1/3"
        :is_include_matter="true"
        @selectSearch="selectSearchMatter"
      />
      <SelectOption
        url="/account/list/"
        label="Responsible Lawyer"
        field="responsible"
        :required="false"
        mode="multiple"
        method="get"
        placeholder="Find a user"
        class="self-end mt-8 md:mt-0 w-full md:w-1/3"
      />
      <BtnSubmitReport
        ref="reportSubmit"
        @backPage="$emit('changeTab','BillingReport')"
      />
    </a-form>
    <ExportPdf
      ref="exportPdf"
      :title="title"
      :pdfForm="form.getFieldsValue(['from_date','to_date'])"
      @onProgress="onProgress"
      @hasDownloaded="hasDownloaded"
    >
      <div id="pdf"></div>
    </ExportPdf>
  </vx-card>
</template>

<script>
import selectSearch from '../../forms/selectSearch'
import SelectOption from '../../forms/SelectOptionSingle'
import mixin from '../../mixin/mixin'
import axios from '@/axios'
import ExportPdf from "@/components/pdf/ExportPdf";
import Actions from "@/components/closeDownloadReport/Actions";
import BtnSubmitReport from "@/components/btn-report-submit/BtnSubmitReport";

const columns = [
  {
    title: 'Bill id',
    dataIndex: 'bill_id',
    key: '1',
    scopedSlots: { customRender: 'bill' },
  },
  {
    title: '0-30',
    dataIndex: '0-30',
    key: '2',
  },
  {
    title: '31-60',
    dataIndex: '31-60',
    key: '3',
  },
  {
    title: '61-90',
    dataIndex: '61-90',
    key: '4',
  },
  {
    title: '+91',
    dataIndex: '+91',
    key: '5',
  },
  {
    title: 'Current',
    dataIndex: 'current',
    key: '6',
    width:'20%'
  },
];

export default {
  name: "ComponentAgentRecivable",
  mixins:[mixin],
  components:{
    BtnSubmitReport,
    Actions,
    ExportPdf,
    selectSearch,
    SelectOption,
  },
  data(){
    return{
      result          : [],
      title:'Accounts Receivable Aging',
      columns,
      radioStyle: {
        display: 'block',
        height: '40px',
        lineHeight: '30px',
      },
    }
  },
  computed: {
    currencySymbol() {
      return localStorage.getItem('currency_symbol')
    },
  },
  methods:{
    handleSubmit() {
      this.form.validateFields(async (err,values) => {
        if (!err) {
          try {
            const query = []
            this.$refs.reportSubmit.loading = true
            if (values.contact)
              query.push({ field:'to_contact', condition: '=', value: values.contact })
            if (values.matter)
              query.push({ field:'matters', condition: '=', value: values.matter })
            if (values.responsible && values.responsible.length)
              query.push({ field:'matters__responsible', condition: 'in', value: values.responsible })
            const {data} = await axios.post('/billing/report/aging/',{ query: query })
            this.result = Object.values(data);
            this.visibleRes = true
          }catch (e) {
            this.visibleRes = false
            this.$message.error('Server Error')
            throw new Error(e)
          }finally {
            this.$refs.reportSubmit.loading = false
          }
        }
      })
    },
    selectSearchMatter() {
      this.form.resetFields('contact')
    },

  }
}
</script>

<style scoped>

</style>
